export const MessageTypes = {
  //Parent messages
  RECEIVED_ANALYTICS: 'HS_CTA_PARENT_RECEIVED_ANALYTICS',
  DEVICE_TYPE: 'HS_CTA_PARENT_DEVICE_TYPE',
  PROXY_ANALYTICS_FN_CALLBACK: 'HS_CTA_PARENT_PROXY_ANALYTICS_FN',
  INIT: 'HS_CTA_PARENT_INIT',
  SHOWING_CTA: 'HS_CTA_SHOWING_CTA',
  SEND_EXTRACTED_STYLES: 'HS_SEND_EXTRACTED_STYLES',
  // Child messages
  STARTED: 'HS_CTA_STARTED',
  NAVIGATE_PAGE: 'HS_CTA_NAVIGATE_PAGE',
  CLICK_EVENT: 'HS_CTA_CLICK_EVENT',
  CLOSE_INTERACTIVE: 'HS_CTA_CLOSE_INTERACTIVE',
  HAS_CLOSED: 'HS_CTA_HAS_CLOSED',
  NEW_HEIGHT: 'HS_CTA_NEW_HEIGHT',
  DISPLAY_CALL_TO_ACTION: 'HS_DISPLAY_CALL_TO_ACTION',
  PROXY_ANALYTICS: 'HS_CTA_PROXY_ANALYTICS',
  PROXY_ANALYTICS_FN: 'HS_CTA_PROXY_ANALYTICS_FN',
  SEND_FORM_DEFINITION: 'HS_SEND_FORM_DEFINITION',
  SEND_CTA_CONFIG: 'HS_SEND_CTA_CONFIG',
  SEND_EMBED_CONTEXT: 'HS_SEND_EMBED_CONTEXT',
  RECEIVE_FILTERED_STYLESHEETS: 'RECEIVE_FILTERED_STYLESHEETS',
  SEND_STYLESHEETS: 'SEND_STYLESHEETS',
  TRIGGER_CTA: 'HS_CTA_TRIGGER_CTA',
  CTA_FORM_SUBMITTED: 'HS_CTA_FORM_SUBMITTED',
  V4_FORM_READY: 'HS_V4_FORM_READY',
  V4_RECAPTCHA_RENDER: 'HS_V4_RECAPTCHA_RENDER',
  V4_RECAPTCHA_EXECUTE: 'HS_V4_RECAPTCHA_EXECUTE',
  V4_RECAPTCHA_RESET: 'HS_V4_RECAPTCHA_RESET',
  V4_RECAPTCHA_SUCCESS: 'HS_V4_RECAPTCHA_SUCCESS',
  V4_RECAPTCHA_EXPIRED: 'HS_V4_RECAPTCHA_EXPIRED',
  SEND_FORM_EXTRA_SUBMISSION_METADATA: 'HS_SEND_FORM_EXTRA_SUBMISSION_METADATA',
  SEND_FORM_SUBMISSION_SUCCESS_INFO: 'HS_SEND_FORM_SUBMISSION_SUCCESS_INFO',
  SEND_FORM_SUBMISSION_SUCCESS: 'HS_SEND_FORM_SUBMISSION_SUCCESS',
  SEND_FORM_SUBMISSION_FAILED: 'HS_SEND_FORM_SUBMISSION_FAILED',
  SEND_FORM_INTERACTION_NAVIGATE: 'HS_SEND_FORM_INTERACTION_NAVIGATE',
  SEND_FORM_INTERACTION_NAVIGATE_NEXT: 'HS_SEND_FORM_INTERACTION_NAVIGATE_NEXT',
  SEND_FORM_INTERACTION_NAVIGATE_PREVIOUS: 'HS_SEND_FORM_INTERACTION_NAVIGATE_PREVIOUS',
  GET_FORM_FIELD_VALUES: 'HS_GET_FORM_FIELD_VALUES',
  SEND_FORM_FIELD_VALUES: 'HS_SEND_FORM_FIELD_VALUES',
  GET_FIELD_VALUE: 'HS_GET_FIELD_VALUE',
  SET_FIELD_VALUE: 'HS_SET_FIELD_VALUE',
  SEND_FIELD_VALUE: 'HS_SEND_FIELD_VALUE',
  MEETINGS_BOOKING_SUCCESS: 'HS_CTA_MEETINGS_BOOKING_SUCCESS'
};